import { getShareContact as ShareContact } from '@/api/passenger'
import { shareUpdate as shareUpdateContact } from '@/api/passenger'
import { deleteShareContact as deleteContact } from '@/api/passenger'

const getShareContact = (context, params) => {
  return ShareContact(params).then((response) => {
    return response
  })
}

const shareUpdate = (context, params) => {
  return shareUpdateContact(params).then((response) => {
    return response
  })
}

const deleteShareContact = (context, params) => {
  return deleteContact(params).then((response) => {
    return response
  })
}

export default {
  getShareContact,
  shareUpdate,
  deleteShareContact
}
